module.exports = __webpack_public_path__ + "img/mood_smile.a4b626fb.png";